import { createContext, useContext, useEffect, useState } from "react";
import { navTabs } from "../constants/common.constants";
import { useSelector } from 'react-redux'

const CarrommContext = createContext(null);

export const useCarromm = () => useContext(CarrommContext);

export const CarrommProvider = ({ children }) => {
  const [input, setInput] = useState(null);
  const { dimension } = useSelector(state => state.carromm);
  const [tabs, setTabs] = useState(navTabs || []);

  useEffect(() => {
    if (dimension !== "") {
      const filteredTabs = navTabs.filter(
        (tab) => !tab.hasOwnProperty("isSpecific") || tab.isSpecific === dimension
      );
      setTabs(filteredTabs);
    }
  },[dimension]);

  return (
    <CarrommContext.Provider
      value={{
        input,
        setInput,
        tabs,
        setTabs
      }}>
      {children}
    </CarrommContext.Provider>
  );
}